import { useContext } from 'react';

import { ProspectorContext, ProspectorMachine } from './Provider';

export function useProspector() {
  const [state, send] = useContext(ProspectorContext);

  return [state, send] as ProspectorMachine;
}
